import { render, staticRenderFns } from "./CardsContainer.vue?vue&type=template&id=bdf2d78c&"
import script from "./CardsContainer.vue?vue&type=script&lang=js&"
export * from "./CardsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports